import { memo } from 'react'
import { Image } from '../HOC/Image'
import { getAvatarUrl } from '@/helpers/getAvatarUrl'
import { Box } from '@chakra-ui/react'

export const avatarListComponent = [
  'QmUsXeXwWCEJyPykeR4omCrJfT2YePeJnLRSCAjEzQ2zNL',
  'Qmdm3Fdw3fWbL8JN46ecbR2kkvcxT2D423FJwYbZn4hWR6',
  'QmQV63KPeD55Bhh6JXQovnQNi2QLdAf75LFqtUrbsrMRjJ',
  'Qmd62DxhjCFrNV9uStysSek2uPW5XEZJfXkbxbgHDwEzWP',
  'QmY7SjgLAnUxXvEhsJuATkYbKsPDRo1ovR1sgktQu7W5iH',
]

export const AvatarSet = memo(({ onClick }: { onClick: (id: string) => void }) => {
  return avatarListComponent.map((x) => (
    <Box onClick={() => onClick(x)} key={x}>
      <Image
        cursor="pointer"
        width={52}
        height={52}
        key={x}
        rounded={'full'}
        src={getAvatarUrl(x) || ''}
        boxSize={{ base: '52px' }}
        alt=""
      />
    </Box>
  ))
})
